import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
import { routes } from './nav/Nav';

class BackButton extends React.Component {
  render() {
    let currentRoute = routes.find(route => route.path === this.props.location.pathname);
    let currentIndex = routes.indexOf(currentRoute);
    if (currentIndex <= 0) {
      currentIndex = routes.length;
    }
    currentIndex--;
    
    if (this.props.location.pathname === '/full-poem') {
      return null;
    }

    return (
      <Link to={routes[currentIndex].path} className="button back-button secondary">
       <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon>
        <span>GO BACK</span>
      </Link>
    );
  }
}

export default BackButton;
